import { GrispiInputProps } from '../../index';
import GrispiAutocompleteSelectInput from './GrispiAutocompleteSelectInput';
import GrispiStandardSelectInput from './GrispiStandardSelectInput';

type GrispiSelectInputProps = Omit<GrispiInputProps<'SELECT'>, 'type'>;

const GrispiSelectInput = (props: GrispiSelectInputProps) => {
    const { fieldKey, isNewValueAllowed, ...rest } = props;
    if (!fieldKey) return <GrispiStandardSelectInput {...rest} />;
    return <GrispiAutocompleteSelectInput {...props} fieldKey={fieldKey} isNewValueAllowed={isNewValueAllowed} />;
};

export default GrispiSelectInput;
